import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Sidebar.module.scss";
import { useNavLinks } from "../../constants/navLinks";
import { useTheme } from "../../contexts/ThemeContext";
import { t } from "i18next";
import ExitIcon from "../../assets/icons/sidebar/ExitIcon";
import { logout } from "../../api/authApi";
import { useNotification } from "../../contexts/NotificationToast";

const Sidebar = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const location = useLocation();
  const navLinks = useNavLinks();
  const { theme } = useTheme();
  const handleLogout = async () => {
    try {
      const response = await logout();
      console.log("Logout response:", response);

      if (response?.status === 200) {
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("access_token");
        showNotification("Logout successful", 200);
        navigate("/auth/login");
      } else {
        console.error("Logout failed: ", response);
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };
  return (
    <aside className={styles.sidebar}>
      <nav className={styles.sidebarNavigation}>
        {navLinks.map((item, idx) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={idx}
              to={item.path}
              className={`${styles.navLink} ${
                isActive ? styles.navLinkActive : ""
              }`}
            >
              {React.cloneElement(item.icon, {
                color:
                  theme === "dark"
                    ? isActive
                      ? "#0A61F5"
                      : "white"
                    : isActive
                    ? "#0A61F5"
                    : "currentColor",
              })}
              <p>{item.name}</p>
            </Link>
          );
        })}
      </nav>
      <button className={styles.logoutButton} onClick={handleLogout}>
        <ExitIcon color={theme === "dark" ? "white" : "currentColor"} />
        <p>{t("logout")}</p>
      </button>
    </aside>
  );
};

export default Sidebar;
